import React, { type FC, useMemo, memo } from 'react'
import { Flex, Avatar, Typography } from 'antd'
import { Location20Regular } from '@fluentui/react-icons'

import {
  getAbbreviation,
  getAvatarBackgroundColor
} from '../../constants/helpers/common'
import { type IOktaUser } from '../../constants/types/generatedTypesAliases'

const { Title, Text } = Typography

interface IUsersAvatarBlockProps {
  users: IOktaUser[]
}

export const UsersAvatarBlock: FC<IUsersAvatarBlockProps> = memo(({ users }) => {
  const { firstName, lastName, email = '', timeZone = '' } = users[0] || {}

  const abbreviations = useMemo(() => (
    users.map(user => (
      getAbbreviation(user.firstName ?? '', user.lastName ?? '')
    ))
  ), [users])

  return (
    <>
      {
        (users.length > 1)
          ? (
              <Flex className='avatars-block' align='center' gap={20}>
                <div>
                  {
                    abbreviations.map((abbr, index) => (
                      <Avatar
                        key={abbr + index}
                        data-testid='user-selected-avatar'
                        className='avatar__group'
                        style={{ backgroundColor: getAvatarBackgroundColor(abbr) }}>
                        {abbr}
                      </Avatar>
                    ))
                  }
                </div>
                <Title level={4}>{users.length} Users selected</Title>
              </Flex>
            )
          : (
              <Flex className='avatars-block' gap={10} align='center'>
                <Avatar
                  size={72}
                  data-testid='user-avatar_large'
                  className='avatar__large'>
                  {getAbbreviation(firstName ?? '', lastName ?? '')}
                </Avatar>
                <div className='avatars-block__wrapper'>
                  <Title
                    level={4}
                    className='avatars-block__title'>
                    {firstName} {lastName}
                  </Title>
                  <Flex justify='space-between'>
                    <Text>{email}</Text>
                    <Flex align='center'>
                      <Location20Regular className='location-icon' />
                  &nbsp;
                      <Text>{timeZone}</Text>
                    </Flex>
                  </Flex>
                </div>
              </Flex>
            )
      }
    </>
  )
})
